import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { SHOPS_LIST } from '../shop-state';

export const LOAD_SHOPS_LIST = '[Shop] Load shop list';
export const LOAD_SHOPS_LIST_FAILURE = '[Shop] Load shop list fail';
export const LOAD_SHOPS_LIST_SUCCESS = '[Shop] Load shop list Success';
export const LOAD_SHOPS_LIST_RESET = '[Shop] Load shop list Reset';

export class LoadShopList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_SHOPS_LIST;

  constructor() {
    super(SHOPS_LIST);
  }
}

export class LoadShopListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_SHOPS_LIST_FAILURE;

  constructor(public payload: any) {
    super(SHOPS_LIST, payload);
  }
}

export class LoadShopListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_SHOPS_LIST_SUCCESS;

  constructor(public payload: Pos[]) {
    super(SHOPS_LIST);
  }
}

export class ResetShopList extends StateUtils.LoaderResetAction {
  readonly type = LOAD_SHOPS_LIST_RESET;

  constructor() {
    super(SHOPS_LIST);
  }
}

export type ShopActions = LoadShopList | LoadShopListSuccess | LoadShopListFail | ResetShopList;
